import { render } from "./VisitGT.vue?vue&type=template&id=5100634e"
import script from "./VisitGT.vue?vue&type=script&lang=js"
export * from "./VisitGT.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__